import React, { PropTypes } from 'react';
import _ from 'lodash';
import update from 'react-addons-update'; // https://facebook.github.io/react/docs/update.html

// components
import Option from './Option';

const ChoiceButtons = (props) => {
    const { activeId, mode, widget, actions } = props;

    const optionClick = (option, e) => {
        e.preventDefault();

        if (mode === 'CLIENT') {
            if (widget.type === 'Single Choice') {
                actions.saveResultAndCheckChoiceWidget([option.id], widget, activeId);
            } else {
                const widgetOptions = update(widget.options, {
                    [option.id]: {
                        checked: { $set: option.checked !== true },
                    },
                });
                const optionIds = _.map(widgetOptions, (option) => {
                    if (option.checked) {
                        return option.id;
                    }
                });
                actions.saveResultAndCheckChoiceWidget(optionIds, widget, activeId);
            }
        }
    };

    return (
        <div className="choice-group">
            {_.map(widget.options, (option) => {
                return (
                    <div className="choice" key={option.id} onClick={optionClick.bind(this, option)}>
                        <Option option={option} widget={widget} />
                    </div>
                );
            })}
        </div>
    );
};

ChoiceButtons.propTypes = {
    activeId: PropTypes.number.isRequired,
    mode: PropTypes.string.isRequired,
    widget: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default ChoiceButtons;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Choice/ChoiceButtons.jsx